import { Component } from 'react';
import { RootState } from '../../../store';
import { connect } from 'react-redux';
import { AppSelect } from '../../shared/Select';
import { ILocalization } from '../../../localization/definitions/types';
import './ContactAdminForm.css';
import { toast } from 'react-toastify';
import { sendEmailToAdmins } from '../../../api/sendEmails';
import SusyFormField from '../../shared/forms/SusyFormField/SusyFormField';
import { ConfirmationModal } from '../../shared/modals/confirmationModal/ConfirmationModal';
import { User } from '../../../store/types';
import { UserRoles } from '../../../utils';
import SusyInput from '../../shared/forms/SusyInput';

interface ContactAdminFormProps {
    localization: ILocalization;
    currentUser: User | null;

    showModal: boolean;
    onHideModal: () => void;
}

interface ContactAdminFormState {
    emailSubject: string;
    bodyMessage: string;
}

class ContactAdminForm extends Component<ContactAdminFormProps> {
    state: ContactAdminFormState = {
        emailSubject:
            this.props.currentUser?.userRole.key === UserRoles.user
                ? this.props.localization.localizationStrings.susy.navbar
                      .contactAdminButton.contactAdminModal
                      .emailHelpRegistration
                : '',
        bodyMessage: '',
    };

    applyValueToState = (name: string, value: string) => {
        this.setState({ ...this.state, [name]: value });
    };

    sendMessageToAdmins = async () => {
        const mailSubject =
            this.state.emailSubject !== ''
                ? this.state.emailSubject
                : this.props.localization.localizationStrings.susy.navbar
                      .contactAdminButton.contactAdminModal
                      .supervisorRequestedHelp;
        await sendEmailToAdmins(mailSubject, this.state.bodyMessage);
        toast.success(
            this.props.localization.localizationStrings.susy.navbar
                .contactAdminButton.contactAdminModal.emailSent
        );
        this.props.onHideModal();
    };

    emailHelpReasons = [
        {
            value: 'registration',
            label: this.props.localization.localizationStrings.susy.navbar
                .contactAdminButton.contactAdminModal.emailHelpRegistration,
        },
        {
            value: 'findSupervisor',
            label: this.props.localization.localizationStrings.susy.navbar
                .contactAdminButton.contactAdminModal.emailHelpFindSupervisor,
        },
        {
            value: 'selectingResearchArea',
            label: this.props.localization.localizationStrings.susy.navbar
                .contactAdminButton.contactAdminModal
                .emailHelpSelectingResearchArea,
        },
        {
            value: 'finalVersion',
            label: this.props.localization.localizationStrings.susy.navbar
                .contactAdminButton.contactAdminModal.emailHelpFinalVersion,
        },
        {
            value: 'finalGrade',
            label: this.props.localization.localizationStrings.susy.navbar
                .contactAdminButton.contactAdminModal.emailHelpFinalGrade,
        },
    ];

    getModalTitle = () => {
        const localization =
            this.props.localization.localizationStrings.susy.navbar
                .contactAdminButton;
        return this.props.currentUser?.userRole.key === UserRoles.supervisor
            ? localization.modalTitleSupervisor
            : localization.modalTitleUser;
    };

    getModalBody = () => {
        return (
            <div
                className='contact-admin-form'
                data-testid='contact_admin_form'
            >
                <SusyFormField
                    label={{
                        fieldIdentifier: 'typeOfMessage',
                        text: this.props.localization.localizationStrings.susy
                            .navbar.contactAdminButton.contactAdminModal
                            .typeOfMessageLabel,
                    }}
                >
                    {this.props.currentUser?.userRole.key ===
                        UserRoles.user && (
                        <AppSelect
                            name='message-type'
                            onChange={(m: any) =>
                                this.applyValueToState('emailSubject', m.value)
                            }
                            options={this.emailHelpReasons}
                        />
                    )}
                    {this.props.currentUser?.userRole.key ===
                        UserRoles.supervisor && (
                        <SusyInput
                            name='message-type'
                            onChange={(e) =>
                                this.applyValueToState(
                                    'emailSubject',
                                    e.target.value
                                )
                            }
                        />
                    )}
                </SusyFormField>

                <SusyFormField
                    label={{
                        fieldIdentifier: 'message',
                        text: this.props.localization.localizationStrings.susy
                            .navbar.contactAdminButton.contactAdminModal
                            .writeMessageLabel,
                    }}
                >
                    <textarea
                        className='form-control contact-admin-form-message'
                        placeholder={
                            this.props.localization.localizationStrings.susy
                                .navbar.contactAdminButton.contactAdminModal
                                .messagePlaceholder
                        }
                        name='bodyMessage'
                        id='message'
                        onChange={(e) =>
                            this.applyValueToState(
                                'bodyMessage',
                                e.target.value
                            )
                        }
                    />
                </SusyFormField>
            </div>
        );
    };

    render() {
        const localization =
            this.props.localization.localizationStrings.susy.navbar
                .contactAdminButton;
        return (
            <ConfirmationModal
                showModal={this.props.showModal}
                onHide={this.props.onHideModal}
                title={this.getModalTitle()}
                onConfirm={this.sendMessageToAdmins}
                cancelButtonText={localization.cancelButton}
                confirmButtonText={localization.confirmButton}
                confirmButtonTestId='send-message-button-test-id'
                modalBody={this.getModalBody()}
            />
        );
    }
}

const mapStateToProps = (state: RootState) => {
    return {
        localization: state.localization,

        currentUser: state.auth.currentUser,
    };
};

export default connect(mapStateToProps, {})(ContactAdminForm);
